'use strict'

define ['./applicationChangeOwnerModal.scss'], () ->
  ($q, $scope, $rootScope, $uibModalInstance, Application, $cacheFactory, Flash) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.new_owner = ""
    $scope.error_message = ""
    
    $scope.change_owner = () ->
      $scope.is_removing = true
      promises = []

      for bundle in $scope.bundles
        for app in bundle.applications
          promises.push(Application.change_owner({id: app.id, owner: $scope.new_owner }).$promise)
      
      $q.all(promises)
        .then () ->
          Flash.create('success', "Application owner has been changed to #{$scope.new_owner}", 4000, {class: 'change-success'}, true);
          $scope.is_removing = false
          $rootScope.$broadcast 'refresh-appbundle-table'
          $uibModalInstance.close()
        .catch (err) ->
          $scope.error_message = err.data.message or "Error has occurred. Please contact support."



// WEBPACK FOOTER //
// ./directives/applicationChangeOwnerModal/applicationChangeOwnerModal.coffee